import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

const SECURITY_BEST_PRACTICES_CHECK_EXCEPTIONS_QUERY_KEY =
  'security-best-practices-check-exceptions';

export const getBestPracticeCheckExceptionsQueryKey = (ruleId: string) =>
  [SECURITY_BEST_PRACTICES_CHECK_EXCEPTIONS_QUERY_KEY, ruleId] as const;

const getBestPracticeCheckExceptionsQueryOptions = (ruleId: string) =>
  queryOptions({
    queryKey: getBestPracticeCheckExceptionsQueryKey(ruleId),
    queryFn: async () => {
      const { data } = await apiClient.securityInsights.getCheckExceptions({
        ruleId,
      });
      return data;
    },
  });

export const useBestPracticeCheckExceptionsQuery = (ruleId: string) => {
  const {
    isLoading,
    data: exceptions,
    error,
    refetch,
  } = useQuery(getBestPracticeCheckExceptionsQueryOptions(ruleId));

  return { isLoading, exceptions, error, refetch };
};
